import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const creditTypes: Record<string, string> = {
  '1': 'Agency Law',
  '2': 'Legal Issues',
  '3': 'Fair Housing',
  '4': 'Contract Law',
  '5': 'Comm. Standards',
  '6': 'Disclosure',
  '7': 'General',
  '8': 'NONE',
  '9': 'Req. For Licensees'
};
export function EditCreditType() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  const name = id && creditTypes[id] ? creditTypes[id] : '';
  return <div className="space-y-4" data-id="element-712" data-mp="1npsphzxf7s84">
      <div className="flex items-center justify-between" data-id="element-713" data-mp="1rpb6wlq19l67">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-714" data-mp="1rpurka72innx">
          {isEdit ? 'Edit Credit Type' : 'Add Credit Type'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types')} data-id="element-715" data-mp="3m3lu6pqzc79v">
          ← Back to Credit Types
        </Button>
      </div>

      <Card data-id="element-716" data-mp="1a039fj8dx4eq">
        <CardContent className="pt-6" data-id="element-717" data-mp="1a0mi09c5agg3">
          <form className="space-y-4 max-w-sm" data-id="element-718" data-mp="19zjv0chy0y5g">
            <Input label="Name" defaultValue={name} data-id="element-719" data-mp="1519z1zoe9tis" />
            <div className="pt-2" data-id="element-720" data-mp="151s33ihatc19">
              <Button type="submit" data-id="element-721" data-mp="hbfo5nnmyf16">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}